import React from "react";
import {radioListCreator} from "./radioListCreator";
import './radio.sass'

function subCreator(props) {
    if (props.subModel) {
        let sub = radioListCreator(props.subModel, props.onChange)
        return <div className="sub1">
            <div className="arrow"/>
            {sub}
        </div>
    } else {
        return ''
    }
}

function RadioInput(props) {
    return (
        <div
            className={'list__option'}>
            <input key={props.keys}
                   onChange={e => props.onChange(e)}
                   name={props.name}
                   value={props.value}
                   type="radio"
                   id={props.value + props.title + props.name}
                   checked={props.checked}
                   className={'RadioInput'}
            />
            <label
                htmlFor={props.value + props.title + props.name}>{props.title}</label>
            {subCreator(props)}
        </div>
    )
}


export default RadioInput
